export default function paramsToQs(params) {
  return Object.entries(params)
    .map((entry) => `${entry[0]}=${encodeURIComponent(entry[1])}`)
    .join("&");
}
